interface GreenAddButtonProps {
  title: string;
  onClick: () => void;
}

const GreenAddButton = ({ title, onClick }: GreenAddButtonProps) => {
  return (
    <div className="col-md-1 flex-shrink-1">
      <button
        className="btn btn-ghost-success fs-20 d-flex align-items-center justify-content-center"
        style={{ width: '40px', height: '40px' }}
        title={title}
        onClick={onClick}
        type="button"
      >
        +
      </button>
    </div>
  );
};

export default GreenAddButton;
